import { createFileRoute } from "@tanstack/react-router";
import RoPrivacy from "@/pages/legal/RoPrivacy";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/privacy/")({
  head: () => routeHead("/privacy/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <RoPrivacy />
  );
}
